/**
 * @generated SignedSource<<bad937a64bc3ecc1fa450c7c1fe09f36>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductTaskState = "CANCELLED" | "COMPLETED" | "ERROR" | "PARTIAL_SUCCESS" | "PROCESSING" | "WAITING";
export type CreateProductTaskRequestInput = {
  assignPricingRules: boolean;
  cloneTemplates?: boolean | null;
  destinationProductIds: ReadonlyArray<number>;
  destinationProducts: ReadonlyArray<DestinationProductDtoInput>;
  salesChannelId?: number | null;
  sourceProductId: number;
};
export type DestinationProductDtoInput = {
  id: number;
  imageUrl?: string | null;
  name?: string | null;
  sku?: string | null;
  statusId?: number | null;
};
export type productDuplicationTaskQueriesCreateMutation$variables = {
  request: CreateProductTaskRequestInput;
};
export type productDuplicationTaskQueriesCreateMutation$data = {
  readonly createProductTask: {
    readonly createdOn: string;
    readonly id: string;
    readonly isLocked: boolean;
    readonly modifiedOn: string;
    readonly progress: {
      readonly completedOperations: number;
      readonly overallProgress: number;
      readonly totalOperations: number;
    } | null;
    readonly settings: {
      readonly assignPricingRules: boolean;
      readonly cloneTemplates: boolean | null;
      readonly destinationProductIds: ReadonlyArray<string>;
      readonly salesChannelId: number | null;
      readonly sellerID: number;
      readonly sourceProductId: string;
      readonly userID: number | null;
    } | null;
    readonly status: number;
    readonly taskID: number;
    readonly taskState: ProductTaskState;
    readonly type: string;
  };
};
export type productDuplicationTaskQueriesCreateMutation = {
  response: productDuplicationTaskQueriesCreateMutation$data;
  variables: productDuplicationTaskQueriesCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "ProductTaskDto",
    "kind": "LinkedField",
    "name": "createProductTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskState",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isLocked",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "modifiedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductTaskSettingsDto",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceProductId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "destinationProductIds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cloneTemplates",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assignPricingRules",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "salesChannelId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sellerID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userID",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductTaskProgressDto",
        "kind": "LinkedField",
        "name": "progress",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalOperations",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "completedOperations",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "overallProgress",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productDuplicationTaskQueriesCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "productDuplicationTaskQueriesCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "86ef30660d327de173a564dc2f98844d",
    "id": null,
    "metadata": {},
    "name": "productDuplicationTaskQueriesCreateMutation",
    "operationKind": "mutation",
    "text": "mutation productDuplicationTaskQueriesCreateMutation(\n  $request: CreateProductTaskRequestInput!\n) {\n  createProductTask(request: $request) {\n    id\n    taskID\n    type\n    status\n    taskState\n    isLocked\n    createdOn\n    modifiedOn\n    settings {\n      sourceProductId\n      destinationProductIds\n      cloneTemplates\n      assignPricingRules\n      salesChannelId\n      sellerID\n      userID\n    }\n    progress {\n      totalOperations\n      completedOperations\n      overallProgress\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "db7d2dba2994d0f3cc44d138c407e721";

export default node;
